import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { noNeeds, oneSeed } from '../data/content';
export function MissionTransition() {
  return <section aria-labelledby="mission-title" className="bg-cream" data-id="element-209" data-mp="350s8jgt74b05">
      <div className="mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 lg:py-28" data-id="element-210" data-mp="3a2pxmroa2010">
        <h2 id="mission-title" className="text-balance font-display text-[40px] leading-[1.05] text-navy sm:text-[56px]" data-id="element-211" data-mp="3f116p06r06i6">
          Du kennst den Auftrag bereits.
        </h2>
        <p className="mt-5 text-lg text-ink-soft" data-id="element-212" data-mp="2mc3qd2m3kjs2">Jesus hat uns längst gesagt: Geht hin.</p>
        <p className="mt-8 text-lg text-ink-soft" data-id="element-213" data-mp="2rb6v0ly60nzi">Die Frage ist:</p>
        <p className="mt-2 font-display text-[28px] leading-tight text-coral sm:text-[34px]" data-id="element-214" data-mp="2r9lxcngk0oxf">
          Wirst du weiter auf den „perfekten Moment“ warten, um anzufangen?
        </p>
        <ul className="mx-auto mt-10 max-w-xl space-y-2 text-lg text-ink-soft" data-id="element-215" data-mp="1ylq5bw1xjl6z">
          {noNeeds.map(n => <li key={n} data-id="element-216" data-mp="23k1cu04r5jm1">{n}</li>)}
        </ul>
        <p className="mt-8 text-lg font-bold text-navy" data-id="element-217" data-mp="3ks77wtdlhpeo">Du kannst mit etwas ganz Einfachem anfangen.</p>
        <ol className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-218" data-mp="3fsb52xgmw40p">
          {oneSeed.map((s, i) => <li key={s} className="flex items-center gap-3" data-id="element-219" data-mp="3b0jlj6vwayk2" data-mpi={i}>
              {i > 0 && <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-220" data-mp="3712hmhw4a9h0" />}
              <span className={`font-display text-2xl sm:text-3xl ${i === oneSeed.length - 1 ? 'text-leaf-deep' : 'text-navy'}`} data-id="element-221" data-mp="320wn8tygq8v8">{s}</span>
            </li>)}
        </ol>
        <p className="mt-4 font-display text-2xl italic text-ink-soft" data-id="element-222" data-mp="2x4fwrt3sjiez">Und dann das nächste.</p>
      </div>
    </section>;
}